'use strict';

angular.module('kerp-forms.forms').factory('KR_CA_CONDITIONS', ['FormConditions', function (FormConditions) {

  return FormConditions.clone({
    conditions: {}
  });
}]);
